import { Component, inject, Input, OnDestroy, OnInit, signal } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { BehaviorSubject } from 'rxjs';

import { AssignmentAttendanceModalComponent } from '../assignment-attendance-modal/assignment-attendance-modal.component';

@Component({
    selector: 'app-assignment-attendance',
    templateUrl: './assignment-attendance.component.html',
    styleUrl: './assignment-attendance.component.scss'
})
export class AssignmentAttendanceComponent implements OnInit, OnDestroy {
    @Input({ required: true }) assignmentId!: number;
    @Input() deadline: Date | null = null;

    protected isReadonly = signal(false);
    private readonlyIntervalId?: number;

    private bsModalService = inject(BsModalService);

    ngOnInit(): void {
        this.updateReadonly();

        this.readonlyIntervalId = window.setInterval(() => {
            this.updateReadonly();
        }, 1000);
    }

    ngOnDestroy(): void {
        if (this.readonlyIntervalId != null) {
            clearInterval(this.readonlyIntervalId);
        }
    }

    protected openModal(): void {
        this.bsModalService.show(AssignmentAttendanceModalComponent, {
            class: 'modal-lg',
            ignoreBackdropClick: true,
            initialState: {
                assignmentId: this.assignmentId,
                isReadonly: this.isReadonly()
            }
        });
    }

    private updateReadonly(): void {
        const isReadonly = this.isDeadlinePassed(this.deadline);
        this.isReadonly.set(isReadonly);
    }

    private isDeadlinePassed(deadline: Date | null): boolean {
        if (!deadline) return false;
        return new Date().getTime() > deadline.getTime();
    }
}
